import React from 'react';
import ReactDOM from 'react-dom/client';
// MUSS vor App stehen: verbindet die (gecachte) Functions-Instanz mit dem Emulator,
// bevor ein Modul auf Modulebene getFunctions aufruft. Ohne Emulator-Flag ein No-op.
import './firebase/functions';
// App Check früh anstoßen, damit beim ersten /api/-Aufruf schon ein Token bereitliegt.
// Ohne REACT_APP_RECAPTCHA_SITE_KEY ein No-op — das SDK wird dann nicht einmal geladen.
import { ensureAppCheck } from './firebase/appCheck';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

ensureAppCheck();

// Frühzeitiger Capture – bevor React mountet, damit PwaLanding immer Zugriff hat
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__pwaInstallEvent = e;
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('[PWA] App cached successfully for offline use.');
  },
  onUpdate: (registration) => {
    const event = new CustomEvent('swUpdateReady', { detail: registration });
    window.dispatchEvent(event);
  },
});

reportWebVitals();
